const Tick3DIcon = () => {
    return (
        <svg
            width='280'
            height='237'
            viewBox='0 0 280 237'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M163.986 100.681V135.106C163.986 136.291 163.399 137.4 162.418 138.065L157.507 141.4L126.701 121.261C123.271 119.02 121.058 115.331 120.693 111.25L117.428 74.6865L122.686 71.5143C123.794 70.8457 125.177 70.8278 126.303 71.4677L157.219 89.0478C161.402 91.4267 163.986 95.8688 163.986 100.681Z'
                fill='white'
                stroke='#090B2A'
                strokeWidth='0.301148'
            />
            <path
                d='M163.988 100.681V135.106C163.988 136.291 163.401 137.4 162.42 138.065L157.509 141.4L158.135 103.543L163.974 100.079C163.983 100.279 163.988 100.48 163.988 100.681Z'
                fill='#090B2A'
                stroke='#090B2A'
                strokeWidth='0.301148'
            />
            <path
                d='M116 112.72V77.53C116 74.7864 118.961 73.0638 121.346 74.4201L151.948 91.8216C156.132 94.2006 158.716 98.6426 158.716 103.455V138.734C158.716 141.481 155.748 143.204 153.363 141.84L122.742 124.339C118.573 121.956 116 117.522 116 112.72Z'
                fill='#EFE8E0'
                stroke='#090B2A'
                strokeWidth='0.301148'
            />
            <path
                d='M120.363 110.27V81.0537C120.363 80.0375 121.46 79.3995 122.343 79.9018L147.747 94.3472C151.93 96.7261 154.514 101.168 154.514 105.981V135.271C154.514 136.288 153.415 136.926 152.532 136.421L127.105 121.889C122.936 119.506 120.363 115.072 120.363 110.27Z'
                stroke='#090B2A'
                strokeWidth='0.301148'
            />
            <path
                d='M128.541 100.907L134.138 111.715C134.175 111.787 134.268 111.806 134.331 111.756L144.721 103.345C145.974 102.33 147.813 102.53 148.819 103.79C149.813 105.035 149.62 106.847 148.386 107.854L135.999 117.966C135.178 118.635 133.95 118.387 133.454 117.452L125.522 102.49C125.037 101.576 125.472 100.444 126.444 100.09C127.249 99.7965 128.147 100.146 128.541 100.907Z'
                fill='white'
                stroke='#090B2A'
                strokeWidth='0.301148'
            />
            <circle
                cx='138.5'
                cy='106.5'
                r='98.5'
                stroke='#DFD6CB'
                strokeLinecap='round'
                strokeDasharray='1 4'
            />
            <circle
                cx='138.875'
                cy='106.5'
                r='73.875'
                stroke='#DFD6CB'
                strokeLinecap='round'
                strokeDasharray='1 4'
            />
        </svg>
    );
};

export default Tick3DIcon;
